import React from 'react';
import Paper from '@mui/material/Paper';
import { withStyles } from 'tss-react/mui';

import {
  updateTransactions,
  getTransactions
} from '../../../actions/Transactions';
import TransactionsTable from '../../TransactionsTable/index';
import { withDisplaying } from '../../../hoc';

const styles = {
  div: {
    width: '100%'
  },
};

class Transactions extends React.Component {
  state = {
    transactions: [],
  }

  componentDidMount() {
    getTransactions(this.props.inter.id).then(transactions =>
      this.setState({
        transactions
      })
    );
  }

  updateTransactions = (newData, oldData) =>
    updateTransactions(newData, oldData).then(() => {
      getTransactions(this.props.inter.id).then(transactions =>
        this.setState({
          transactions
        })
      );
    })

  render() {
    const { transactions } = this.state;

    return (
      <Paper>
        <TransactionsTable
          title="Transactions"
          data={transactions}
          editable={{
            isEditable: () => true,
            onRowUpdate: this.updateTransactions,
          }}
          options={{
            actionsColumnIndex: -1
          }}
        />
      </Paper>
    );
  }
}

export default withDisplaying()(withStyles(Transactions, styles));
